<template>
  <div id="activity-zone-container">
    <div v-if="activityZonesList">
      <div class="zone-list-container">
        <template v-for="(zone, id) in zonesWithRSSI">
          <activity-zone-list-item
            :key="id"
            :zone="zone"
            :signal-loading="signalStrengthsLoading"
            :signal-error="signalStrengthsError"
            @edit-zone="onEditZone"
          />
        </template>
      </div>
    </div>
    <div
      v-else
      class="loader-container"
    >
      <div
        v-for="n in 4"
        :key="n"
        class="d-flex flex-column"
      >
        <div class="d-flex justify-start align-center">
          <v-skeleton-loader
            type="image"
            loading
          />
          <div
            class="d-flex flex-column loader-text-container"
          >
            <v-skeleton-loader
              type="text@2"
              loading
            />
          </div>
        </div>
        <v-divider />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ActivityZoneListItem from '@/components/activityZones/ActivityZoneListItem'

  export default {
    name: 'ZonesList',
    components: { ActivityZoneListItem },
    props: {
      activityZonesList: Array,
    },
    data () {
      return {
        signalStrengthsLoading: true,
        signalStrengthsError: false,
      }
    },
    computed: {
      ...mapGetters({
        signalStrengths: 'ActivityZones/signalStrengths',
      }),
      zonesWithRSSI () {
        return this.activityZonesList.map((zone) => {
          const signalStrength = this.signalStrengths.find(({ zoneID }) => zone.id === zoneID)
          if (signalStrength) return { ...zone, RSSI: signalStrength.RSSI }
          return zone
        })
      },
    },
    async created () {
      await this.fetchSignalStrengths()
    },
    methods: {
      onEditZone (zone) {
        // set selected zone to vuex
        this.$store.commit('ActivityZones/updateSelectedZone', zone)
        this.$router.push({ path: `/properties/zone/${zone.id}/edit` })
      },
      fetchSignalStrengths () {
        this.$store.dispatch('ActivityZones/fetchSignalStrengths', this.$route.params.id)
          .catch(() => { this.signalStrengthsError = true })
          .finally(() => { this.signalStrengthsLoading = false })
      },
    },
  }
</script>

<style lang="scss">
#activity-zone-container {
  .loader-container {
    height: 550px;
    .v-skeleton-loader {
      height:100%;
      width:150px;
      padding:30px 0;
      .v-skeleton-loader__image {
        width: 74px;
        height: 74px;
        min-height: 0;
        border-radius: 4px;
      }
    }
  }
  .zone-list-container {
    display: block;
    width: 100%;
  }

}
</style>
